import { Component, ElementRef, Input } from '@angular/core';
import { TotemWidget } from '../totem-widget';
import { ExternalLinksService } from 'pg-lib/pg-ui-elements/external-links.service';
import { AnalyticsService } from 'pg-lib/services/analytics.service';

@Component({
    selector: 'app-totem-widget-details',
    templateUrl: './totem-widget-details.component.html',
    styleUrls: ['./totem-widget-details.component.scss'],
    standalone: false
})
export class TotemWidgetDetailsComponent extends TotemWidget {
    size: 'md' = 'md';

    @Input() detailList: Array<{ icon: string; title: string; subtitle?: string; description?: string; date?: string|Date; link?: string }>;

    constructor(
        public elementRef: ElementRef,
        private externalLinksService: ExternalLinksService,
        private analyticsService: AnalyticsService
    ) {
        super(elementRef);
    }

    checkGoToLink(item: { title: string; link?: string }) {
        if (item?.link != null) {
            this.analyticsService.sendEvent('widgetOpenLink', {
                widget: this.id,
                link: item.link
            });
            this.externalLinksService.openExternalLink(item.link);
        }
    }
}
